"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationConfig = {
    autohideMs: 10000,
    removeAfterHideMs: 500 // wait slide out animation, then hide it
};
//# sourceMappingURL=config.js.map